import * as angular from 'angular';
import * as _ from 'lodash';

import { IobjectAccessRightsService } from '../../services';
import { ObjectAccessRights } from '../../models';
import { Store } from '../Store';
import * as OBJECTACCESSRIGHTS from './objectAccessRights.constants';

import {
    loadObjectAccessRights,
    loadObjectAccessRightsSuccess,
    updateObjectAccessRights,
    updateObjectAccessRightsSuccess,
} from './objectAccessRights.actions';


export interface IObjectAccessRightActionsService {
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<ObjectAccessRights[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<ObjectAccessRights[]>;
    updateOne(target: ObjectAccessRights): (dispatch: any, getState: () => Store) => angular.IPromise<ObjectAccessRights[]>;
}

export class ObjectAccessRightsActionsService implements IObjectAccessRightActionsService {

    static serviceId = 'objectAccessRightActionsService';
    static $inject = ['$q', 'objectAccessRightsService'];


    constructor(
        private _$q: angular.IQService,
        private _objectAccessRightService: IobjectAccessRightsService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { objectAccessRights } = getState();
            if (!objectAccessRights.isLoading && !objectAccessRights.isLoaded) {
                dispatch(loadObjectAccessRights());
                return this._objectAccessRightService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(loadObjectAccessRightsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<ObjectAccessRights>(objectAccessRights.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { objectAccessRights } = getState();
            if (force || (!objectAccessRights.isLoading && !objectAccessRights.isLoaded)) {
                dispatch(loadObjectAccessRights());
                return this._objectAccessRightService.getAll(force)
                    .then(data => {
                        dispatch(loadObjectAccessRightsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ObjectAccessRights>(objectAccessRights.dictionary));
            }
        };
    }

    updateOne(target: ObjectAccessRights) {
        return (dispatch: any, getState: () => Store) => {
            const { objectAccessRights } = getState();
            if (target) {
                dispatch(updateObjectAccessRights([target]));
                return this._objectAccessRightService.update(target)
                    .then(data => {
                        const result = data;
                        dispatch(updateObjectAccessRightsSuccess([result]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: OBJECTACCESSRIGHTS.OBJECT_ACCESS_RIGHTS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<ObjectAccessRights>(objectAccessRights.dictionary));
            }
        };
    }
}